import { cn } from '@seen/ui'
import { forwardRef } from 'react'

export const Card = forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'rounded-lg border border-zinc-200 bg-white p-4 text-zinc-950 shadow-sm dark:border-zinc-800 dark:bg-zinc-950 dark:text-zinc-50',
      '-mx-px', // Account for border for aligning the content with other elements.
      className
    )}
    {...props}
  />
))
Card.displayName = 'Card'
